export type InFlightMap<T> = Record<string, Promise<T>>;

// Shares one pending call per key. A StrictMode double-mount otherwise fires two cold requests at
// once, and izteach-dedicated-learning-site saw exactly that 504 against API Gateway's 29s cap.
export function shareInFlight<T>(map: InFlightMap<T>, key: string, start: () => Promise<T>): Promise<T> {
  const existing = map[key];
  if (existing) return existing;
  const pending = start();
  map[key] = pending;
  // a de-dupe window, not a cache: a signed manifest expires, so the settled promise is dropped
  const forget = () => {
    if (map[key] === pending) delete map[key];
  };
  pending.then(forget, forget);
  return pending;
}
